
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations, StoreActions } from '@/store';
import { Azione, Lavorazione, VariazioneLavorazione } from '@/models';
import { Loading, LavorazioniList } from "@/components";
import dayjs from 'dayjs';

@Component({
    components: {
        Loading,
        LavorazioniList
    }
})
export default class OpzioniOrdine extends Vue {

    private ids: string[] = [];
    private azione: string = '';
    private dialog = false;
    private selezione: string[] = [];

    get loading () {
        return store.state.loading;
    }

    get negoziazione(): boolean {
        return this.azione == Azione.RICHIEDI_VARIAZIONE;
    }

    get azioniPossibili(): string[] {
        let azioni: string[] = [];
        store.state.azioniLavorazioni.forEach(azLav => {
            azLav.azioni.forEach(azione => {
                if(azione != Azione.AGGIORNA_LAVORAZIONE && azioni.indexOf(azione) < 0) {
                    azioni.push(azione);
                }
            })            
        });
        return azioni;
    }

    eseguiAzione(az: string) {

        this.azione = az;
        this.dialog = true;
        //store.commit(StoreMutations.SetOpzioniVisibili, false);

        // filtro gil id delle lavorazioni su cui posso eseguire l'azione selezionata
        this.ids = store.state.azioniLavorazioni.filter(azLav => azLav.azioni.some(a => a == az)).map(azLav => azLav.idLavorazioneDpc);
        this.selezione = this.ids.concat([]);

        // "carico" le lavorazioni risultanti dal filtraggio precedente
        store.dispatch(StoreActions.GetLavorazioni, this.ids);
    }

    async completaAzione() {
        if(this.selezione.length == 0) {
            store.commit(StoreMutations.SetMessaggiErrore, ["Nessuna lavorazione selezionata!"]);
            return;
        }

        if(this.negoziazione) {
            if(!this.date || this.date.length == 0) {
                store.commit(StoreMutations.SetMessaggiErrore, ["Data per richiesta variazione non specificata!"]);
                return;
            }

            let variazione: VariazioneLavorazione = {
                variazioneDataConsegnaProposta: dayjs(this.date).toISOString()
            };

            await store.dispatch(StoreActions.RichiediVariazioniLavorazioni, {
                ids: this.selezione,
                variazione: variazione
            });
        }
        else {
            await store.dispatch(StoreActions.EseguiAzionePerLavorazioni, { ids: this.selezione, azione: this.azione });
        }
        this.dialog = false;
        store.commit(StoreMutations.SetOpzioniVisibili, false);
    }

    get lavorazioni(): Lavorazione[] {
        return store.state.gruppoLavorazioni.concat()
            .sort((lavA, lavB) => {
                if (lavA.priorita < lavB.priorita) { return 1; }
                if (lavA.priorita > lavB.priorita) { return -1; }
                if (lavA.dataConsegna > lavB.dataConsegna) { return 1; }
                if (lavA.dataConsegna < lavB.dataConsegna) { return -1; }
                if (lavA.progresso > lavB.progresso) { return 1; }
                if (lavA.progresso < lavB.progresso) { return -1; }
                return 0;                
            });
    }

//#region gestione negoziazione data

    date: string = '';
    dateFormatted: string = '';
    menu1 = false;

    get computedDateFormatted () {
        return this.formatDate(this.date);
    }

    @Watch('date')
    onDateChange(): void {
        this.dateFormatted = this.formatDate(this.date)
    }

    formatIsoDate(date: string): string {
        if (!date) return '';

        return dayjs(date).format('DD/MM/YYYY');
    }

    formatDate (date: string): string {
        if (!date) return '';

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string): string {
        if (!date) return '';

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

//#endregion gestione negoziazione data
}

